import React, { useEffect, useState } from 'react';
import {
    Container,
} from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { LOGOUT } from 'ConstComponents';
import { SelectByID as TRANSACTION_SELECT_BY_ID } from 'Components/Api/NSDLOnboardingAPI';
import { StatusDataDisplay } from 'Pages/InnerPages/NSDLOnboarding/OnboardingDataDisplay';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const ViewData = ({ OnbaordingID, onDismissCallback }) => {
    const classes = commonStyle();

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [headerStatus, setheaderStatus] = useState();
    useEffect(() => {
        selectByID(OnbaordingID);
    }, [OnbaordingID]);

    const selectByID = async (OnbaordingID) => {

        let JSONObj = {
            OnboardingID: OnbaordingID
        };
        setLoading(true);
        var request = JSON.stringify(JSONObj);

        const response = await TRANSACTION_SELECT_BY_ID(request);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        var data = JSON.parse(response.data);
        setheaderStatus(data);
    };
    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <StatusDataDisplay headerStatus={headerStatus} />
        </CustomContainer>
    );
};
